import HttpClient from '@/api/http/client'
import config from '@/config'
import store from 'store'
import windowStore from '@/store/modules/window.store'
import NewResponseError from '@/api/http/NewResponseError'

const http = new HttpClient(config.appsBuilderBaseUrl)

const PLATFORM = 'web_browser'

const supportedLanguageVersions = new Map([
  ['en', 'en-US'],
  ['pt', 'pt-BR'],
  ['es', 'es-MX']
])

function getSupportedLanguage(language) {
  return supportedLanguageVersions.get(language) ?? language
}

function getAuthToken() {
  return localStorage.getItem('accessToken')
}

export default {
  async createPkWebJson(age, appName = 'pkp') {
    const response = await http.sendRequest(`/api/v1/pkweb/${appName}/?age=${age}`, {
      method: 'GET',
      headers: {
        'accept': 'application/json',
        'x-country': store.get('country'),
        'x-platform': PLATFORM,
        'x-language': getSupportedLanguage(windowStore.state.language)
      }
    })
    const responseBody = await response.json()

    if (!response.ok) {
      throw new NewResponseError(response.status, responseBody)
    }

    return responseBody
  },
  async getStreamLinkToVideo(videoId, appName = 'pkp') {
    const response = await http.sendRequest(`/api/v1/catalogs/${appName}/videos/${videoId}/stream`, {
      method: 'GET',
      headers: {
        'accept': 'application/json',
        'x-country': store.get('country'),
        'x-platform': PLATFORM,
        'x-language': getSupportedLanguage(windowStore.state.language),
        'x-app-version': '',
        'Authorization': `Bearer ${getAuthToken()}`
      }
    })

    const responseBody = await response.json()

    if (!response.ok) {
      throw new NewResponseError(response.status, responseBody)
    }

    return responseBody
  }
}
